const STRATEGY_BASE_INSTRUMENT = {
  Abdo: 'ES',
  Avalanche: 'YM',
  Axo: 'NQ',
  BLKZ: 'NQ',
  BeefBowl: 'NQ',
  'BeefBowl 1 micro 100 trigger': 'NQ',
  'CL Night': 'CL',
  'DLG AM': 'NQ',
  'DLG PM': 'NQ',
  'DIP 1': 'NQ',
  'DIP 2': 'NQ',
  Driftwood: 'NQ',
  Exodus: 'NQ',
  'Filet Mignon': 'NQ',
  GM1: 'NQ',
  GM2: 'NQ',
  Genki: 'NQ',
  Gway: 'NQ',
  'GQ Zero Limit': 'NQ',
  'GP 1': 'ES',
  'GP 2': 'ES',
  'GC Night': 'GC',
  'Gold Member': 'NQ',
  'Grass Fed Prime Beef': 'NQ',
  'Grass Fed Prime Beef (Current version 2.1C)': 'NQ',
  'Grass Fed Prime Beef 2.1 (Normal_Trailing)': 'NQ',
  'Grass Fed Prime Beef 2.1 (Step_Trailing)': 'NQ',
  'Grass Fed Prime Beef 2.2': 'NQ',
  'Tuesday Special (Previous 2.2A)': 'NQ',
  MFER: 'NQ',
  MDV: 'NQ',
  'Meat Popsicle': 'NQ',
  NAL: 'NQ',
  NDL: 'NQ',
  'NQ 7AM': 'NQ',
  'NQ 8AM': 'NQ',
  'NQ BMC': 'NQ',
  'NQ CLE': 'NQ',
  'NQ EARLY': 'NQ',
  'NQ JNF': 'NQ',
  'NQ LATER': 'NQ',
  'NQ Malvern': 'NQ',
  'Nozzle Ninja': 'NQ',
  'Nozzle Ninja 1': 'NQ',
  'Nozzle Ninja 2': 'NQ',
  'Nozzle Ninja 3': 'NQ',
  'Nozzle Ninja 4': 'NQ',
  'Nozzle Ninja 5': 'NQ',
  'Nozzle Ninja 6': 'NQ',
  PrimeBeef: 'NQ',
  Scarberia: 'NQ',
  'Scarberia 1 minute': 'NQ',
  'Sokrat ES': 'ES',
  'Sokrat NQ': 'NQ',
  Thorncliffe: 'NQ',
  'Thursday Special': 'NQ',
  VGT: 'NQ',
  'YM Early': 'YM',
  'YM JNF': 'YM',
  'YM MCF': 'YM',
  'YM STL': 'YM',
  'ES 7AM': 'ES',
  '1:1 Strategies': 'NQ',
  'Day Ranges': 'NQ',
  'Night Ranges': 'NQ',
  'Scarberia, Flemo': 'NQ',
  // Both the current and legacy names point to NQ — the synthetic combined
  // sheet uses the same underlying contract as its source strategies.
  'Vector Master Strat': 'NQ',
  'Multi-Strat': 'NQ',
};

const CONTRACT_TYPE_LABELS = {
  NQ: { full: 'NQ', micro: 'MNQ' },
  ES: { full: 'ES', micro: 'MES' },
  YM: { full: 'YM', micro: 'MYM' },
  CL: { full: 'CL', micro: 'MCL' },
  GC: { full: 'GC', micro: 'MGC' },
};

export function getContractTypeLabelsForStrategy(strategyName) {
  const base = STRATEGY_BASE_INSTRUMENT[strategyName] || 'NQ';
  return CONTRACT_TYPE_LABELS[base] || CONTRACT_TYPE_LABELS.NQ;
}

/** Chip labels from an admin-configured or user-entered futures symbol (NQ, MNQ, ES, …). */
export function getContractTypeLabelsForDisplaySymbol(displaySymbol) {
  const raw = String(displaySymbol || 'NQ').trim().toUpperCase();
  const microPrefixes = [
    ['MNQ', 'NQ'],
    ['MES', 'ES'],
    ['MYM', 'YM'],
    ['MCL', 'CL'],
    ['MGC', 'GC'],
  ];
  for (const [micro, full] of microPrefixes) {
    if (raw === micro || raw.startsWith(micro)) {
      return CONTRACT_TYPE_LABELS[full] || CONTRACT_TYPE_LABELS.NQ;
    }
  }
  if (CONTRACT_TYPE_LABELS[raw]) return CONTRACT_TYPE_LABELS[raw];
  return CONTRACT_TYPE_LABELS.NQ;
}

/** Generic labels when a combo mixes NQ, YM, ES, etc. — the toggle is 1× vs 0.1× per native contract. */
export const MIXED_CONTRACT_TYPE_LABELS = { full: 'Reg', micro: 'Micro' };

/**
 * Contract-type chip labels for a custom strat combo. Single-family combos
 * use that family's symbols (NQ/MNQ, YM/MYM, …). Mixed-family combos use
 * Reg / Micro because the view scales each sleeve's native contract.
 */
export function getContractTypeLabelsForCombo(sleeves) {
  if (!Array.isArray(sleeves) || sleeves.length === 0) {
    return CONTRACT_TYPE_LABELS.NQ;
  }
  const families = new Set();
  sleeves.forEach((s) => {
    if (s?.strategy) families.add(getBaseContractTypeForStrategy(s.strategy));
  });
  if (families.size <= 1) {
    const base = families.size === 1 ? [...families][0] : 'NQ';
    return CONTRACT_TYPE_LABELS[base] || CONTRACT_TYPE_LABELS.NQ;
  }
  return MIXED_CONTRACT_TYPE_LABELS;
}

export function comboHasMixedContractFamilies(sleeves) {
  if (!Array.isArray(sleeves) || sleeves.length === 0) return false;
  const families = new Set();
  sleeves.forEach((s) => {
    if (s?.strategy) families.add(getBaseContractTypeForStrategy(s.strategy));
  });
  return families.size > 1;
}

/**
 * Return the base contract family (e.g. "NQ", "YM", "ES") for a strategy
 * name. Falls back to "NQ" for anything we don't recognize. Used to pick
 * contract-type chip labels and detect mixed-family custom strat combos.
 */
export function getBaseContractTypeForStrategy(strategyName) {
  return STRATEGY_BASE_INSTRUMENT[strategyName] || 'NQ';
}
